import React from 'react';
import { Helmet } from 'react-helmet';

function Error_Seo() {
    return (
        <div>
            <Helmet>
                <title>404 | Ifepay</title>
                <meta name="description" content="" />
                <meta property="og:title" content="404 | Ifepay" />
                <meta property="og:description" content="" />
                <meta property="og:image" content="https://ifepay.co.uk/assets/images/logo.png" /> {/* Replace with actual image URL */}
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://ifepay.co.uk/404"/>
            </Helmet>
        </div>
    )
}

export default Error_Seo
